export default __webpack_public_path__ + "static/media/featured_area_toronto.0df31a30.webp";